import store from 'reduxStore/store';
import clickUseDeskAnalytic from 'utils/analitic/clickUseDeskAnalytic';

const subscribeClickUseDesk = () => {
  if (typeof window !== undefined) {
    window.onload = function () {
      const usedesk = document.getElementById('usedesk-messenger');
      if (usedesk) {
        usedesk.addEventListener(
          'click',
          () => {
            const user = store.getState().auth?.user;
            clickUseDeskAnalytic(user);
          },
          {
            once: true,
          }
        );
      }
    };
  }
};

export default subscribeClickUseDesk;
